export const actions = {
  CONSULTA_EMAILS_LOAD_REQUESTED: 'CONSULTA_EMAILS_LOAD_REQUESTED',
  CONSULTA_EMAILS_LOAD_SUCCEEDED: 'CONSULTA_EMAILS_LOAD_SUCCEEDED',
  CONSULTA_EMAILS_LOAD_FILED: 'CONSULTA_EMAILS_LOAD_FILED',

  CONSULTA_EMAIL_UPDATE_REQUESTED: 'CONSULTA_EMAIL_UPDATE_REQUESTED',
  CONSULTA_EMAIL_UPDATE_SUCCEEDED: 'CONSULTA_EMAIL_UPDATE_SUCCEEDED',
  CONSULTA_EMAIL_UPDATE_FILED: 'CONSULTA_EMAIL_UPDATE_FILED',

  CONSULTA_EMAIL_INSERT_REQUESTED: 'CONSULTA_EMAIL_INSERT_REQUESTED',
  CONSULTA_EMAIL_INSERT_SUCCEEDED: 'CONSULTA_EMAIL_INSERT_SUCCEEDED',
  CONSULTA_EMAIL_INSERT_FILED: 'CONSULTA_EMAIL_INSERT_FILED',

  CONSULTA_EMAIL_DELETE_REQUESTED: 'CONSULTA_EMAIL_DELETE_REQUESTED',
  CONSULTA_EMAIL_DELETE_SUCCEEDED: 'CONSULTA_EMAIL_DELETE_SUCCEEDED',
  CONSULTA_EMAIL_DELETE_FILED: 'CONSULTA_EMAIL_DELETE_FILED',
}

export const getConsultaEmailsAction = dispatch => {
  dispatch({
    type: actions.CONSULTA_EMAILS_LOAD_REQUESTED,
  })
}

export const onSubmitInsertConsultaEmailFormAction = (dispatch, formConsultaEmail) => {
  dispatch({
    type: actions.CONSULTA_EMAIL_INSERT_REQUESTED,
    payload: formConsultaEmail,
  })
}

export const onSubmitUpdateConsultaEmailFormAction = (dispatch, formConsultaEmail) => {
  dispatch({
    type: actions.CONSULTA_EMAIL_UPDATE_REQUESTED,
    payload: formConsultaEmail,
  })
}

export const deleteConsultaEmailAction = (dispatch, id) => {
  dispatch({
    type: actions.CONSULTA_EMAIL_DELETE_REQUESTED,
    payload: id,
  })
}
